import React from 'react';
import { compose } from 'react-apollo';
import { Helmet } from 'react-helmet';
import ProfileRewards from 'containers/ProfileDetailsPage/ProfileRewards';
import withPatronAssetsData from 'containers/ProfileDetailsPage/withPatronAssetsData';
import withPatronRewardsData from 'containers/ProfileDetailsPage/withPatronRewardsData';
import withPlsRewardsData from 'containers/ProfileDetailsPage/withPlsRewardsData';
import CloseButton from 'components/CloseButton';
import LoadingIndicator from 'components/LoadingIndicator';
import PageOverlay from 'components/PageOverlay';
import { getUserData } from 'utils/graphQLFunctions';
import { hasPatronAccount, hasPlsAccount } from 'utils/roles';
import './RewardsPage.scss';

const RewardsListWithPatronData = compose(withPatronRewardsData)(
  ProfileRewards
);

const RewardsListWithPlsData = compose(withPlsRewardsData)(ProfileRewards);

const RewardsListWithFullData = compose(
  withPatronRewardsData,
  withPlsRewardsData
)(ProfileRewards);

const RewardsListWithLimitedData =
  compose(withPatronAssetsData)(ProfileRewards);

function RewardsPage({ userData }) {
  const user = userData.user;
  if (userData.loading && !user) {
    return <LoadingIndicator expand />;
  } else if (userData.error || !user) {
    return (
      <div className="alert alert-danger">
        Failed to retrieve player info. If this continues, please contact
        support.
      </div>
    );
  }

  const getRewardsListComponent = () => {
    if (hasPatronAccount(user) && hasPlsAccount(user)) {
      return RewardsListWithFullData;
    } else if (hasPatronAccount(user)) {
      return RewardsListWithPatronData;
    } else if (hasPlsAccount(user)) {
      return RewardsListWithPlsData;
    } else {
      return RewardsListWithLimitedData;
    }
  };
  const RewardsListComponent = getRewardsListComponent();

  return (
    <div className="rewards-page">
      <PageOverlay>
        <Helmet>
          <title>Rewards</title>
        </Helmet>
        <div className="rewards-page-title-container">
          <h1 className="rewards-page-title">Rewards</h1>
        </div>
        <RewardsListComponent userData={userData} />
        <CloseButton url="/" />
      </PageOverlay>
    </div>
  );
}

export default getUserData({
  name: 'userData'
})(RewardsPage);
